import React from 'react'
import { useTranslation } from 'react-i18next'
import ErrorMessage from 'components/share/ErrorMessage'
import { WidgetGuard } from 'features/types'

import useSideBySideData from '../hooks/useSideBySideData'

const SideBySideEmptyResultGuard: WidgetGuard = ({ widgetId, children }) => {
  const { isAllEmpty, isDataChanged } = useSideBySideData(widgetId)
  const { t } = useTranslation()

  return isAllEmpty && isDataChanged ? (
    <ErrorMessage>{t('emptyBecauseLowCount')}</ErrorMessage>
  ) : (
    children
  )
}

export default SideBySideEmptyResultGuard
